// extracted by mini-css-extract-plugin
export default {"date":"date___rW4NH"};